import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasskeyManagementCmsKey = 'Header' | 'Caption' | 'LearnMore' | 'CreatePasskey';

export const PasskeyManagementPanelCmsWithDefault: CmsObjectWithDefault<PasskeyManagementCmsKey> = {
    Header: {
        cmsId: 553051,
        defaultTranslation: 'Passkeys',
    },
    Caption: {
        cmsId: 553052,
        defaultTranslation:
            'Use passkeys as a second step with your password. Keep screen locks and security keys private.',
    },
    LearnMore: {
        cmsId: 541404,
        defaultTranslation: 'Learn more',
    },
    CreatePasskey: {
        cmsId: 541405,
        defaultTranslation: 'Create a passkey',
    },
};
